import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { OverlayInjectedProps } from 'react-bootstrap/esm/Overlay';
import styled from 'styled-components';

import { useOngoingShift, useTimezone } from '@/hooks';

interface ITooltipProps {
  children: React.ReactElement;
  showTime?: number;
  hideTime?: number;
  placement: OverlayInjectedProps['placement'];
}

const TimeTooltip = ({ placement, showTime, hideTime, children }: ITooltipProps): React.ReactElement => {
  const { officialTime } = useOngoingShift();
  const { timezoneName, timezoneAbbreviation } = useTimezone();
  const { t } = useTranslation();

  const renderTooltip = (props: OverlayInjectedProps) => (
    <StyledTooltip id="button-tooltip" {...props}>
      <div>
        <p className="time-zone">{timezoneName}</p>
        <p>
          {t`common.timeZone`}: {timezoneAbbreviation}
        </p>
        <p>
          {t`common.time`}: {officialTime.time}
        </p>
      </div>
    </StyledTooltip>
  );

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: showTime || 250, hide: hideTime || 500 }}
      overlay={renderTooltip}
    >
      {children}
    </OverlayTrigger>
  );
};

const StyledTooltip = styled(Tooltip)`
  .tooltip-arrow {
    &::before {
      border-left-color: #135188;
    }
  }
  .tooltip-inner {
    background: #135188;
    border-radius: 4px;
    padding: 4px 8px;

    p {
      margin: 0;
      color: #ffffff;
      font-size: 13px;
      line-height: 16px;
      text-align: start;
    }
    .time-zone {
      font-weight: 600;
    }
  }
`;

export { TimeTooltip };
